import { Link } from "gatsby"
import React, { useEffect, memo } from "react"
import AOS from "aos"
import "aos/dist/aos.css"
import MoreButtonArrowIcon from "../svg/MoreButtonArrowIcon"
import * as style from "./relatedBlog.module.css"
import SectionsTitle from "../../Common/new/SectionsTitle"

const RelatedBlog = ({
  blogList,
  relatedBlogsShowSection,
  relatedBlogsTitle,
  relatedBlogsSubTitle,
  relatedBlogsContent,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  return (
    <>
      {relatedBlogsShowSection === "yes" && (
        <section className={style.blog}>
          <div className="container">
            <div className={style.blog_wrap}>
              <SectionsTitle
                title={relatedBlogsTitle}
                SubTitle={relatedBlogsSubTitle}
                Content={relatedBlogsContent}
                btnName="View All"
                href="/blogs"
              />
            </div>
            <ul
              className={style.blog_listing}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {blogList?.map((it, index) => {
                const { slug, title } = it.node
                return (
                  <li key={slug} title={title}>
                    <Link to={`/blogs/${slug}`}>
                      <h3>{title}</h3>
                      <i>
                        {" "}
                        <MoreButtonArrowIcon />{" "}
                      </i>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(RelatedBlog)
